import React from 'react';
import ScrollIntoView from '../components/ScrollIntoView';
import { Link, useLocation } from "react-router-dom";

const Szechenyi = () => {
  return (
    <ScrollIntoView>
      <div id="szechenyi-page">
        
        <Link className='szechenyi_section' id='szechenyi_energia' to="/szechenyi/energia"></Link>

      </div>

    </ScrollIntoView>
  );
};

export default Szechenyi;